import { render, staticRenderFns } from "./ProvidedDataAddNewValueForm.vue?vue&type=template&id=2395997a&scoped=true&lang=pug"
import script from "./ProvidedDataAddNewValueForm.vue?vue&type=script&lang=ts"
export * from "./ProvidedDataAddNewValueForm.vue?vue&type=script&lang=ts"
import style0 from "./ProvidedDataAddNewValueForm.vue?vue&type=style&index=0&id=2395997a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395997a",
  null
  
)

/* custom blocks */
import block0 from "./ProvidedDataAddNewValueForm.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FQuestionnaire%2Fcomponents%2FAnswerBlocks%2Fcomponents%2FProvidedDataSelect%2FProvidedDataAddNewValueForm.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports